import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import reportWebVitals from './reportWebVitals';
import './index.scss';
import App from './App';
import UserService from './services/UserService';

import store from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const renderApp = () =>
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </Provider>
);
UserService.initKeycloak(renderApp);
reportWebVitals();
